import { createFileRoute } from "@tanstack/react-router";
import { TermlyPolicyPage } from "@/knowmeno/TermlyPolicyPage";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — KnowMeno" },
      { name: "description", content: "The terms that govern your use of KnowMeno, including subscriptions, trials, cancellations, and acceptable use of the service." },
      { property: "og:title", content: "Terms of Service — KnowMeno" },
      { property: "og:description", content: "The terms that govern your use of KnowMeno, including subscriptions, trials, cancellations, and acceptable use of the service." },
      { property: "og:url", content: "https://www.knowmeno.com/terms" },
    ],
    links: [{ rel: "canonical", href: "https://www.knowmeno.com/terms" }],
  }),
  component: () => (
    <TermlyPolicyPage dataId="370e4eb5-31fd-4f63-b533-dd687f11dc97" title="Terms of Service" />
  ),
});
